import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "@src/store/hooks";
import { systemActions } from "@src/store";

export type CommonHelpType = "Listing" | "Event" | "Fulfillment";

export const useCommonHelpOptions = (type: CommonHelpType) => {
	const dispatch = useAppDispatch();
	const { data, init, loading } = useAppSelector((state) => state.system.commonHelp);

	useEffect(() => {
		if (!init && !loading) dispatch(systemActions.listCommonHelp({}));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const options = useMemo(
		() =>
			data
				.filter((item) => item.Help_Type === type || item.Help_Type === "Both")
				.map((item) => ({ label: item.Help_Desc, value: item.Help_Desc })),
		[data, type],
	);

	return { options, isLoading: loading };
};
